import React, { memo } from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import SummaryTable from '../summary/SummaryTable';
import { SummaryField } from '../summary/summaryApi';
import { EXCEL_BUTTON_SX } from '../summary/summaryStyles';
import { DirectorPharmacy } from './directorApi';

/** Высота таблицы одной аптеки: на странице их до десяти, каждая прокручивается сама */
const TABLE_MAX_HEIGHT = 420;

const STATUS_TEXT: Record<string, string> = {
  empty: 'За выбранный месяц данных нет',
  no_table: 'У аптеки нет таблицы отчетов'
};

interface Props {
  pharmacy: DirectorPharmacy;
  fields: SummaryField[];
  canExport: boolean;
  /** Идет загрузка или выгрузка: кнопка Excel недоступна */
  busy: boolean;
  exporting: boolean;
  onExport: (pharmacy: DirectorPharmacy) => void;
}

/** Одна аптека: заголовок, кнопка Excel и таблица месяца (или короткая строка, если данных нет) */
const DirectorPharmacyBlock: React.FC<Props> = ({ pharmacy, fields, canExport, busy, exporting, onExport }) => {
  const hasData = pharmacy.status === 'ok';

  return (
    <Box sx={{ mb: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1, minHeight: 32 }}>
        <Typography sx={{ fontSize: '1.02rem', fontWeight: 700, color: '#1e293b' }}>
          Аптека №{pharmacy.pharmacyNum}
        </Typography>
        {pharmacy.fullName && (
          <Typography sx={{ fontSize: '0.84rem', color: '#64748b' }}>{pharmacy.fullName}</Typography>
        )}
        <Box sx={{ flexGrow: 1 }} />
        {hasData ? (
          canExport && (
            <Button
              variant="contained"
              size="small"
              onClick={() => onExport(pharmacy)}
              disabled={busy}
              startIcon={exporting ? <CircularProgress size={14} color="inherit" /> : <FileDownloadIcon />}
              sx={EXCEL_BUTTON_SX}
            >
              Excel
            </Button>
          )
        ) : (
          <Typography sx={{ fontSize: '0.84rem', color: '#94a3b8' }}>{STATUS_TEXT[pharmacy.status]}</Typography>
        )}
      </Box>
      {hasData && (
        <SummaryTable
          fields={fields}
          rows={pharmacy.rows}
          totals={pharmacy.totals}
          maxHeight={TABLE_MAX_HEIGHT}
        />
      )}
    </Box>
  );
};

export default memo(DirectorPharmacyBlock);
